import React, { Component } from 'react';
import { Link } from 'react-router';
import glamorous from 'glamorous';
import { css } from 'glamor';
import HeaderNavSubmenu from './HeaderNavSubmenu';
import ResponsiveLogo from './ResponsiveLogo';
import Container from './Container';
import HeaderNavLink from './HeaderNavLink';
import Avatar from '../../common/Avatar';
import icons from './icons';
import { dimensions } from '../../../style';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

const navBarHeight = 60;

const NavBar = glamorous.div({
  position: 'fixed',
  background: "white",
  zIndex: 1000,
  width: '100%',
  top:0
},
  ({hiddenMobile}) => (
    hiddenMobile ? {
    [dimensions.SCREEN_MAX_SM]: {
      display: 'none'
    }
  } : undefined)
);

const LogoWrapper = glamorous.div({
  margin: '11px 30px 5px 5px',
  [dimensions.SCREEN_MAX_XS]: {
    margin: '11px 11px 5px 5px'
  }
});

const SubmenuContainer = glamorous.div({
  position: 'relative'
});

const UserNavItem = glamorous.div({
  color: '#545454',
  paddingLeft: '12px',
  paddingRight: '12px',
  verticalAlign: 'baseline',
  display: 'inline-block',
  height: '60px',
  lineHeight: '60px',
  cursor: 'pointer',
  position: 'relative',
});

const UserButton = glamorous.span({
  display: 'inline-block',
  width: '34px',
  height: '34px',
  verticalAlign: 'middle'
});

const NavMenuRight = glamorous.div({
  marginLeft: 'auto',
  display: 'flex',
});

class Header extends Component {
  state = {
    menuOpen: false,
  }

  submenuClickHandler = (e) => {
    document.addEventListener('click', this.outsideSubmenuClickHandler, {once: true});

    this.setState({menuOpen: !this.state.menuOpen});
    document.body.classList.toggle('is-globalNavPopoverActive');
  }

  outsideSubmenuClickHandler = (e) => {
    if(this.state.menuOpen) {
      this.setState({menuOpen: false});
      document.body.classList.remove('is-globalNavPopoverActive');
    }
  }

  render() {
    const {
      location,
      alreadyUpgraded,
      username,
      avatar,
      newFavorites,
      messages,
      hiddenMobile
    } = this.props;

    return (
      <NavBar hiddenMobile={hiddenMobile}>
        <Container
          fullWidth
          css={{display: 'flex', [dimensions.SCREEN_MAX_SM]: {justifyContent: 'space-between'} }}
        >
          <LogoWrapper>
            <Link
              to="/dashboard"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                flexBasis: '100%',
                alignItems: 'center'
              }}
            >
              <ResponsiveLogo />
            </Link>
          </LogoWrapper>
          <HeaderNavLink
            to="/search"
            currentPath={location.pathname}
            activePathPattern={/.*search/}
            iconComponent={icons.search}
          />
          <HeaderNavLink
            to="/favorites"
            currentPath={location.pathname}
            activePathPattern={/.*favorites/}
            iconComponent={icons.favorites}
            notification={newFavorites}
          />
          <HeaderNavLink
            to="/trips"
            currentPath={location.pathname}
            activePathPattern={/.*trips/}
            iconComponent={icons.trips}
          />
          <NavMenuRight>
            <HeaderNavLink
              to="/mail"
              currentPath={location.pathname}
              activePathPattern={/.*mail/}
              iconComponent={icons.mail}
              notification={messages}
            />
            <UserNavItem onClick={this.submenuClickHandler}>
              <UserButton>
                <Avatar src={avatar} alt="avatar" />
              </UserButton>
            </UserNavItem>
          </NavMenuRight>
        </Container>
        <Container relative={true}>
          <HeaderNavSubmenu
            active={this.state.menuOpen}
            alreadyUpgraded={alreadyUpgraded}
            username={username}
          />
        </Container>
      </NavBar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/blocks/HeaderNav/Header.jsx